"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactModal = require("react-modal");
var TpaModal_st_css_1 = require("./TpaModal.st.css");
var dist_1 = require("../../assets/icons/dist");
var TpaModal = /** @class */ (function (_super) {
    tslib_1.__extends(TpaModal, _super);
    function TpaModal(props) {
        var _this = _super.call(this, props) || this;
        _this.containerRef = React.createRef();
        _this.getParentNode = _this.getParentNode.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        _this.state = {
            isRendered: false,
        };
        return _this;
    }
    TpaModal.prototype.closeModal = function () {
        var onRequestClose = this.props.onRequestClose;
        onRequestClose();
    };
    TpaModal.prototype.getParentNode = function () {
        return this.containerRef.current;
    };
    TpaModal.prototype.componentDidMount = function () {
        this.setState({
            isRendered: true,
        });
    };
    TpaModal.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, children = _a.children, isMobile = _a.isMobile;
        var isRendered = this.state.isRendered;
        return (React.createElement("div", tslib_1.__assign({ ref: this.containerRef }, TpaModal_st_css_1.default('root', { mobile: isMobile }), { "data-hook": "react-modal-container" }), isRendered ? (React.createElement(ReactModal, { isOpen: isOpen, className: TpaModal_st_css_1.default.modal, onRequestClose: this.closeModal, overlayClassName: TpaModal_st_css_1.default.overlay, parentSelector: this.getParentNode, ariaHideApp: false },
            React.createElement("div", { className: TpaModal_st_css_1.default.closeButton, onClick: this.closeModal, "data-hook": "modal-close-button" },
                React.createElement(dist_1.CloseIcon, null)),
            children)) : null));
    };
    return TpaModal;
}(React.PureComponent));
exports.default = TpaModal;
//# sourceMappingURL=TpaModal.js.map